<template>
  <div class="shared-link-copy-dialog-box">

    <el-dialog
      width-size="medium"
      :title="fileName"
      @close="$emit('close')"
      visible>

      <div class="mx-24 my-24 el-text el-text--size-xs">
        <div style="margin-bottom: 13px;">
          {{ $t('wre-dashboard.shared-link-dialog-box.share-view.message') }}
        </div>
        <el-card
          class="px-24 py-24"
          style="background-color: #f6f8fb;">
          <el-input
            id="shared-link-input"
            class="shared-link-copy-input"
            v-model="linkUrl"
            :disabled="isInProgress"
            size="small"/>
        </el-card>
        <div
          class="lighter-text el-text el-text--caption"
          style="margin-top: 13px; margin-bottom: -4px;"
        >
          {{ $t('wre-dashboard.shared-link-dialog-box.share-view.label.shared', linkInfo) }}
        </div>
      </div>

      <template #footer-aside>
        <el-button
          icon="i-cog--16"
          type="text"
          @click="$emit('settings', linkId)"
          :disabled="isInProgress"
        >
          {{ $t('wre-dashboard.shared-link-dialog-box.share-view.button.manage') }}
        </el-button>
      </template>
      <template #footer>
        <el-button
          native-type="button"
          @click.stop.prevent="onCopy()"
          :loading="isInProgress"
          :disabled="isInProgress"
        >
          {{ $t('wre-dashboard.shared-link-dialog-box.share-view.button.copy') }}
        </el-button>

      </template>
    </el-dialog>

  </div>
</template>

<script>

export default {
  name: 'SharedLinkCopyDialogBox',
  props: {
    fileName: {
      type: String,
      default: '',
      required: true
    },
    linkId: {
      type: Number,
      default: 0,
      required: true
    },
    linkUrl: {
      type: String,
      default: '',
      required: true
    },
    creationDate: {
      type: String,
      default: '',
      required: true
    },
    isInProgress: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    linkInfo() {
      return {
        creationDate: this.$options.filters.date(this.creationDate, 'medium')
      };
    }
  },
  methods: {
    onCopy() {
      const inputElement = document.querySelector('#shared-link-input');
      inputElement.setAttribute('type', 'text');
      inputElement.select();
      try {
        document.execCommand('copy');
        this.$notify.info({
          message: this.$t('wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied'),
          duration: 1000
        });
      } catch (err) {
        this.$notify.error({
          message: this.$t('wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error')
        });
        console.log('link copy error.', err);
      }

      // this.$gtm.push({
      //   event: 'Acronis',
      //   eventCategory: 'WR_sharing',
      //   eventAction: 'Copy_link',
      //   eventLabel: ''
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
  .lighter-text {
    color: $av-fixed-lighter;
  }
</style>
